/** Years between a date of birth and a reference date. Null when dob is missing. */
export function patientAgeYears(
  dob?: string | Date | null,
  at?: string | Date | null
): number | null {
  if (!dob) return null;
  const birth = new Date(dob);
  if (Number.isNaN(birth.getTime())) return null;
  const current = at ? new Date(at) : new Date();
  if (Number.isNaN(current.getTime())) return null;

  let years = current.getFullYear() - birth.getFullYear();
  const birthdayNotYet =
    current.getMonth() < birth.getMonth() ||
    (current.getMonth() === birth.getMonth() &&
      current.getDate() < birth.getDate());
  if (birthdayNotYet) years -= 1;
  return years < 0 ? null : years;
}

export function formatDoctorName(doctor: any): string {
  const title = String(doctor?.title ?? "").trim();
  const name = [doctor?.firstName, doctor?.lastName]
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join(" ");
  if (!name) return title;
  if (!title) return name;
  const titleCore = title.replace(/\.$/, "").toLowerCase();
  const nameLower = name.toLowerCase();
  if (
    nameLower.startsWith(title.toLowerCase()) ||
    nameLower.startsWith(`${titleCore} `) ||
    nameLower.startsWith(`${titleCore}.`)
  ) {
    return name;
  }
  return `${title} ${name}`;
}

/** Qualifications, designation, and SLMC from the employee Professional Details section. */
export function formatDoctorProfessionalDetails(doctor: any): string {
  if (!doctor) return "";
  const studies = Array.isArray(doctor.studies)
    ? doctor.studies
        .map((item: unknown) => String(item ?? "").trim())
        .filter(Boolean)
        .join(", ")
    : String(doctor.studies ?? "").trim();
  const designation = String(doctor.designation ?? "").trim();
  const slmc = String(doctor.slmcNumber ?? "").trim();
  return [studies, designation, slmc ? `SLMC Reg ${slmc}` : ""]
    .filter(Boolean)
    .join("\n");
}
